exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".no-longer-valid{margin:100px auto;width:400px;font-weight:500}.loading{margin-top:200px}.loading .loading-label{width:600px;margin:auto;text-align:center}.loading .loading-label span{font-size:30px}", ""]);

// exports
